import(/* webpackMode: "eager" */ "/vercel/path0/app/(default)/layout.tsx");
